import * as ReactRouter from 'react-router';
import * as RouterType from './Router6';

const RouterAlias = ReactRouter as any;

export const isLegacy = Boolean(RouterAlias.useHistory);

// eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
const Router = require(`${__dirname}/Router${isLegacy ? '5' : '6'}`) as {
  useLocation: typeof RouterType['useLocation'];
  Switch: typeof RouterType['Switch'];
  getRoute: typeof RouterType['getRoute'];
  useHistory: typeof RouterType['useHistory'];
  withRouter: typeof RouterType['withRouter'];
  matchPath: typeof RouterType['matchPath'];
  BrowserRouter: typeof RouterType['BrowserRouter'];
  HashRouter: typeof RouterType['HashRouter'];
  MemoryRouter: typeof RouterType['MemoryRouter'];
};

export default Router;
